import ManagedErrorToasts from '@/components/error/ManagedErrorToasts';
import AdminPageLayout from '@/components/layout/AdminPageLayout';
import PharmacistShipmentsTabs from '@/components/shipments/PharmacistShipmentsTabs';
import ConsignmentAcknowledgementsTable from '@/components/shipments/tables/ConsignmentAcknowledgementsTable';
import ReplenishmentOrderItemsTable from '@/components/shipments/tables/ReplenishmentOrderItemsTable';
import { PharmacistReplenishmentOrdersProvider } from '@/context/replenishment-orders/PharmacistReplenishmentOrders';
import { PharmacistShipmentsProvider } from '@/context/shipments/PharmacistShipments';
import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';
import { useState } from 'react';

export const tabs = {
  WAREHOUSE_ORDERS: 'warehouseOrders',
  SHIPMENTS: 'shipments',
};
function PharmacistShipments() {
  const { key } = usePortalPartnerBrand();

  const [activeTab, setActiveTab] = useState(tabs.SHIPMENTS);

  return (
    <PharmacistShipmentsProvider>
      <PharmacistReplenishmentOrdersProvider>
        <AdminPageLayout title="Shipments" themeVariant={key} testId="pharmacist-shipments">
          <ManagedErrorToasts />
          <PharmacistShipmentsTabs activeTab={activeTab} toggleTab={(tab: string) => setActiveTab(tab)} />
          {activeTab === tabs.SHIPMENTS && <ConsignmentAcknowledgementsTable />}
          {activeTab === tabs.WAREHOUSE_ORDERS && <ReplenishmentOrderItemsTable />}
        </AdminPageLayout>
      </PharmacistReplenishmentOrdersProvider>
    </PharmacistShipmentsProvider>
  );
}

export default PharmacistShipments;
